import { FileData } from 'src/dataFactory/depositionFactory';
import {
  ApproveDepositionPayload,
  CreateDepositionPayload,
  DeleteParam,
  depositionTypes,
  GetDepositionsParam,
  GetDepositionDetailParam,
  LockDepositionParam,
  RejectPayload,
  RenameFileParam,
  GrantAccessFinalPayload,
  GetDepositionFileParam,
} from './types';

const getDepositions = (
  payload: GetDepositionsParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITIONS,
  payload,
  onSuccess,
  onError,
});

const createDeposition = (
  payload: CreateDepositionPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.CREATE_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const updateDeposition = (
  payload: { body: CreateDepositionPayload; uri: string },
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.UPDATE_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const deleteDeposition = (
  payload: GetDepositionDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.DELETE_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const approveDeposition = (
  payload: ApproveDepositionPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.APPROVE_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const completeDeposition = (
  payload: GetDepositionDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.COMPLETE_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const rejectDeposition = (
  payload: RejectPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.REJECT_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const approveFinalDeposition = (
  payload: GetDepositionDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.APPROVE_FINAL_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const lockDeposition = (
  payload: LockDepositionParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.LOCK_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const getDepositionById = (
  payload: GetDepositionDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITION_BY_ID,
  payload,
  onSuccess,
  onError,
});

const grantAccessFinalDeposition = (
  payload: GrantAccessFinalPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GRANT_ACCESS_FINAL_DEPOSITION,
  payload,
  onSuccess,
  onError,
});

const getDepositionExhibitFiles = (
  payload: GetDepositionFileParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITION_EXHIBIT_FILES,
  payload,
  onSuccess,
  onError,
});

const getDepositionProductionFiles = (
  payload: GetDepositionFileParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITION_PRODUCTION_FILES,
  payload,
  onSuccess,
  onError,
});

const getDepositionFinalFiles = (
  payload: GetDepositionFileParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITION_FINAL_FILES,
  payload,
  onSuccess,
  onError,
});

const setDepositionExhibit = (data?: FileData[]) => ({
  type: depositionTypes.SET_DEPOSITION_EXHIBIT,
  payload: data,
});

const setDepositionFinal = (data?: FileData[]) => ({
  type: depositionTypes.SET_DEPOSITION_FINAL,
  payload: data,
});
const setDepositionProduction = (data?: FileData[]) => ({
  type: depositionTypes.SET_DEPOSITION_PRODUCTION,
  payload: data,
});
const resetDepositionFiles = () => ({
  type: depositionTypes.RESET_FILES,
});

const renameFile = (
  payload: RenameFileParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.RENAME_FILE,
  payload,
  onSuccess,
  onError,
});

const deleteFile = (payload: DeleteParam, onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: depositionTypes.DELETE_FILE,
  payload,
  onSuccess,
  onError,
});

const getDepositionRequester = (
  payload: GetDepositionDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITION_REQUESTER,
  payload,
  onSuccess,
  onError,
});

const getDepositionInvoledParties = (
  payload: GetDepositionDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: depositionTypes.GET_DEPOSITION_INVOLED_PARTIES,
  payload,
  onSuccess,
  onError,
});

export {
  getDepositions,
  getDepositionById,
  getDepositionExhibitFiles,
  getDepositionProductionFiles,
  getDepositionFinalFiles,
  createDeposition,
  updateDeposition,
  deleteDeposition,
  approveDeposition,
  rejectDeposition,
  approveFinalDeposition,
  grantAccessFinalDeposition,
  lockDeposition,
  completeDeposition,
  setDepositionExhibit,
  setDepositionFinal,
  setDepositionProduction,
  resetDepositionFiles,
  renameFile,
  deleteFile,
  getDepositionRequester,
  getDepositionInvoledParties,
};
